import { BaseEntity } from 'src/app/tools/models/baseEntity';


export class ProductAnalysisGroup3 extends BaseEntity {

  productAnalysisGroup3Code : string;
  name                      : string;
  rank                      : string;
   
}